import { type InjectionKey, type ShallowRef } from 'vue';
import { type OrthographicCamera, type Scene, type Vector2 } from 'three';
import { updateLoupeCamera } from '@/views/3d-planner/hipSpine/loupe/loupeCamera';

/** The live X-ray scene handle the viewer publishes for the loupe to render. */
export type LoupeSource = {
    scene: Scene;
    mainCamera: OrthographicCamera;
    mainCanvas: HTMLCanvasElement;
};

export const LOUPE_SOURCE_KEY: InjectionKey<ShallowRef<LoupeSource | null>> =
    Symbol('hip-spine-loupe-source');

export type LoupeFrameDeps = {
    mainCamera: OrthographicCamera;
    getMainCanvasHeightPx: () => number;
    getTarget: () => Vector2 | null;
};

/**
 * Build a per-frame callback that keeps the loupe camera locked on the current
 * drag target. When there is no target (no active drag) it is a no-op, leaving
 * the loupe camera untouched.
 */
export function createLoupeFrameUpdater(
    loupeCamera: OrthographicCamera,
    deps: LoupeFrameDeps,
): () => void {
    return () => {
        const target = deps.getTarget();
        if (!target) return;
        updateLoupeCamera(loupeCamera, {
            mainCamera: deps.mainCamera,
            mainCanvasHeightPx: deps.getMainCanvasHeightPx(),
            target,
        });
    };
}
